import AbsolutePane from './_absolute-pane.js'
import ImageButton from './_image-button.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'SubscribeEventsOnboarding',
  values: {
    closeButtonWrapper: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: 0,
          right: 0,
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              padding: '12px',
            },
          },
        },
        buttonIcon: {
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
        },
      },
    },
    description: {
      configSet: Text,
      configValues: {
        container: {
          padding: '16px 24px 16px 16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
